import clsx from "clsx";
import * as React from "react";

import * as PropTypes from "../prop-types";
import { spsGlobalPropTypes } from "../util";

const propsDoc = {
    inline: "boolean",
};

const propTypes = {
    ...spsGlobalPropTypes,
    inline: PropTypes.bool,
};

export type SpsKeyValueListProps = PropTypes.InferTS<typeof propTypes, HTMLDivElement>;

export function SpsKeyValueList(props: SpsKeyValueListProps) {
    const {
        children,
        className,
        inline,
        "data-testid": testId,
        unsafelyReplaceClassName,
        ...rest
    } = props;

    const keyValueListClass = clsx(
        unsafelyReplaceClassName || "sps-key-value-list",
        inline && "sps-key-value-list--inline",
        className,
    );

    return (
        <div className={keyValueListClass} data-testid={`${testId}`} {...rest}>
            {children}
        </div>
    );
}

Object.assign(SpsKeyValueList, {
    props: propsDoc,
    propTypes,
    displayName: "SpsKeyValueList"
});
